import "../style/Footer.css";

function Footer() {
  return (
    <footer>
      <img className="footer-logo" src="/img/mini_logo.png" alt="L'appart d'Enzo"/>
      <div className="infos">
          <span id="address">6 rue Sadi Carnot, 92120 Montrouge</span>
          <span id="phone-number">(+33) 1 82 19 61 24</span>
      </div>
      <div id="schedules">
        <h3 className="list-title">Horaires d'ouverture</h3>
        <ul id="day-schedules">
          <li>
            <span className="hours">10h00 - 17h00</span>
            <span className="day">Lundi</span>
          </li>
          <li>
            <span className="hours">09h00 - 19h00</span>
            <span className="day">Mardi</span>
          </li>
          <li>
            <span className="hours">09h00 - 19h00</span>
            <span className="day">Mercredi</span>
          </li>
          <li>
            <span className="hours">09h00 - 19h00</span>
            <span className="day">Jeudi</span>
          </li>
          <li>
            <span className="hours">09h00 - 19h00</span>
            <span className="day">Vendredi</span>
          </li>
          <li>
            <span className="hours">09h00 - 19h00</span>
            <span className="day">Samedi</span>
          </li>
        </ul>
      </div>
      <a href="https://www.planity.com/lappart-denzo-92120-montrouge">
      <button className="footer-button">Prendre RDV</button>
      </a>
      <div className="quote">Entrez, détendez-vous.<br/>Vous êtes à l’appart.</div>
      <img className="footer-big-logo" src="/img/mini_logo.png" alt="L'appart d'Enzo"/>
      <span className="discret">Made by Tristan D.</span>
    </footer>
  );
}

export default Footer;
